import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { elementAt } from 'rxjs/operator/elementAt';
@Directive({
  selector: '[noSpace]'
})
export class NoSpaceDirective {
  constructor(private el: ElementRef, private control: NgControl) {

  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event) {
    if (event.key == " ")  {
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/directives/common/no-space.directive.ts